// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__37sgd","savePackageButton":"ClientWallet_savePackageButton__1cLku"};